import { useState } from 'react'
import { showErrorSnackbar } from '../../../components/snackbar/Snackbar'
import { messages } from '../../../constants/strings/messages'
import { Installment, updateBankSlip } from '../../../services/main/updateBankSlip'
import { getOrFailUrlAndBarcodeBankSlip } from '../../../services/main/getUrlAndBarcodeBankSlip'
import { usePromise } from '../../../utils/hooks/usePromise'
import { addSecondBankSlip } from './saveQuantityBankSlip'

const TIME_IN_MILLISECONDS = 5000

export const useGetSecondBankSlip = (
  callbackSuccess: (installment?: any) => void,
  callbackError?: (installment?: any) => void
) => {
  const [awaitGetBarcode, setAwaitGetBarCode] = useState(false)

  const getAwaitGetBarcodeBankSlip = (installment: Installment) => {
    setTimeout(() => {
      getBarcodeBankSlip(installment)
    }, TIME_IN_MILLISECONDS)
  }

  const showErrorDefault = () => {
    showErrorSnackbar(messages.financeScreen_error_second_bank_slip)
  }

  const showError = callbackError ?? showErrorDefault

  const { loading: isGetDuplicateBankSlipLoading, request: getDuplicateBankSlip } = usePromise(updateBankSlip, [], {
    onSuccess: ({ installment, isGeneratingBarcode }) => {
      if (isGeneratingBarcode) {
        setAwaitGetBarCode(true)
        getAwaitGetBarcodeBankSlip(installment)
      } else {
        addSecondBankSlip(installment)
        callbackSuccess(installment)
      }
    },
    onError: installment => {
      setAwaitGetBarCode(false)
      showError([installment])
    },
  })

  const { loading: isGetBarcodeLoading, request: getBarcodeBankSlip } = usePromise(getOrFailUrlAndBarcodeBankSlip, [], {
    onSuccess: installment => {
      setAwaitGetBarCode(false)
      addSecondBankSlip(installment)
      callbackSuccess(installment)
    },
    onError: () => {
      setAwaitGetBarCode(false)
      showError()
    },
  })

  return {
    getDuplicateBankSlip,
    loadingBankSlip: isGetDuplicateBankSlipLoading || isGetBarcodeLoading || awaitGetBarcode,
  }
}
